/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Refund/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Refund({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Refund",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#7C5E0F"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Refund.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-ZhWoPA': alignSelf,'--mt-2-ZhWoPA': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZhWoPA': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZhWoPA': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZhWoPA': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZhWoPA': opacity,'--w-10-ZhWoPA': typeof width === 'number' ? `${width}px` : width,'--h-11-ZhWoPA': typeof height === 'number' ? `${height}px` : height,'--f-12-ZhWoPA': fill,'--a-7-ZhWoPA': isAnimated ? animation : "none",'--sd-8-ZhWoPA': isAnimated ? strokeDashoffset : 0,'--sd-9-ZhWoPA': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Refund.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M6.643.655A.649.649 0 006 0a.649.649 0 00-.643.655v2.618H4.286a.429.429 0 00-.396.27.442.442 0 00.093.475l1.714 1.745a.425.425 0 00.606 0l1.714-1.745a.442.442 0 00.093-.476.429.429 0 00-.396-.27H6.643V.656zM3.225 4.789a1.541 1.541 0 01-.44-1.08h-1.5C.576 3.71 0 4.295 0 5.02v5.672C0 11.414.576 12 1.286 12h9.428c.71 0 1.286-.586 1.286-1.31V5.019c0-.723-.576-1.309-1.286-1.309h-1.5c0 .397-.152.788-.439 1.08L7.061 6.534A1.487 1.487 0 016 6.982c-.398 0-.78-.161-1.06-.448L3.224 4.79zm-.65 3.82a.54.54 0 00-.536.545c0 .302.24.546.536.546h3a.54.54 0 00.535-.546.54.54 0 00-.535-.545h-3zm7.56.545c0 .603-.48 1.091-1.071 1.091a1.081 1.081 0 01-1.072-1.09c0-.603.48-1.091 1.072-1.091.591 0 1.071.488 1.071 1.09z"
 style={{'--f-12-ZhWoPA': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}